import script from "./MyDetailFileFieldWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyDetailFileFieldWidget.vue?vue&type=script&setup=true&lang=ts"

import "./MyDetailFileFieldWidget.vue?vue&type=style&index=0&id=3524d834&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3524d834"]])

export default __exports__